/*
 *  Filename........: app.js
 *  Project.........: logistik-app
 *  @copyright......: YBM Deutschland Andy Puderbach und Stephan Wienczny GBR
 *  @version........: 1.0
 *
 *  @since..........: 10.11.20, 12:05
 *  @author.........: robin
 *
 *  @brief..........:
 */

import Vue from 'vue';
import Vuetify from 'vuetify';
Vue.use(Vuetify);

window.trans = function (translation) {
    var language = document.documentElement.lang;

    return _.get(window.i18n, language + "." + translation);
};

require('./bootstrap');

require('./custom');
require('./daterangepicker');

require('./storage');
require('./order');
require('./avis');
require('./product');
require('./supplier');
require('./customer');
require('./home');
require('./booking');
require('./report');
require('./csvConfig');

import 'jquery-ui/ui/widgets/autocomplete.js';
import 'jquery-ui/ui/widgets/datepicker.js';
import vuex from 'vuex';
import VueI18n from 'vuex-i18n'

Vue.use(vuex);
Vue.use(VueI18n);
Vue.use((Vue) => {
    // Assign a unique id to each component
    let uuid = 0;
    Vue.mixin({
        beforeCreate: function() {
            this.uuid = uuid.toString();
            uuid += 1;
        }

    });

    // Generate a component-scoped id
    Vue.prototype.$id = function(id) {
        return "uid-" + this.uuid + "-" + id;
    };
});

Vue.use((Vue) => {
    Vue.prototype.empty = function (e) {
        switch (e) {
            case "":
            case 0:
            case "0":
            case null:
            case false:
            case typeof (e) == "undefined":
                return true;
            default:
                return false;
        }
    };

    Vue.prototype.$connectors = [];
});


/*jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
    icons: {
        time: 'far fa-clock',
        date: 'far fa-calendar',
        up: 'fas fa-arrow-up',
        down: 'fas fa-arrow-down',
        previous: 'fas fa-chevron-left',
        next: 'fas fa-chevron-right',
        today: 'fas fa-calendar-check',
        clear: 'far fa-trash-alt',
        close: 'far fa-times-circle'
    }
});*/

import './i18n';

import AvisEdit from "./components/AvisEdit";
import DateRangePicker from "./components/DateRangePicker";
import datePicker from 'vue-bootstrap-datetimepicker';
import AutoCompleteTextEdit from './components/AutoCompleteTextEdit';
import AvisItemAppend from './components/AvisItemAppend';
import QuestionModal from './components/QuestionModal';
import AvisModal from './components/AvisModal';
import RebookModal from './components/modals/RebookModal';
import NumberInputSpinner from './components/utils/NumberInputSpinner';
import Modal from "./components/Modal";
import ShippingMethodMappingList from "./components/shippingMethodMapping/ShippingMethodMappingList";
import ShopOverview from "./components/shop/ShopOverview";
import ShippingMethodEdit from "./components/shippingMethod/ShippingMethodEdit";
import ShippingMethodList from "./components/shippingMethod/ShippingMethodList";
import ProviderList from "./components/shippingProvider/ShippingProviderList";
import ProviderEdit from "./components/shippingProvider/ShippingProviderEdit";
import ShippingMethodMappingEdit from "./components/shippingMethodMapping/ShippingMethodMappingEdit";
import VueAutosuggest from "vue-autosuggest";
Vue.use(VueAutosuggest);

Vue.component('example', require('./components/Example.vue'));
Vue.component('errors', require('./components/Errors.vue'));
Vue.component('avis-edit', AvisEdit);
Vue.component('date-picker', datePicker);
Vue.component('date-range-picker', DateRangePicker);
Vue.component('auto-complete-text-edit', AutoCompleteTextEdit);
Vue.component('avis-item-append', AvisItemAppend);
Vue.component('question-modal', QuestionModal);
Vue.component('avis-modal', AvisModal);
Vue.component('rebook-modal', RebookModal);
Vue.component('number-input-spinner', NumberInputSpinner);
Vue.component('modal', Modal);
Vue.component('shipping-method-mapping-list', ShippingMethodMappingList);
Vue.component('shop-overview',ShopOverview);
Vue.component('shipping-method-edit',ShippingMethodEdit);
Vue.component('shipping-method-list',ShippingMethodList);
Vue.component('provider-list',ProviderList);
Vue.component('provider-edit',ProviderEdit);
Vue.component('shipping-method-mapping-edit',ShippingMethodMappingEdit);


// picklist components
import PicklistDataList from './components/picklist/PicklistDataList';
Vue.component('picklists-data-list', PicklistDataList);
import PicklistsEdit from './components/picklist/PicklistsEdit';
Vue.component('picklists-edit', PicklistsEdit);

import OrderDataList from "./components/order/OrderDataList";
Vue.component('order-data-list', OrderDataList);

import DialogCard from './components/utils/dialogs/DialogCard';
Vue.component('dialog-card', DialogCard);


const apps = require.context('../../modules', true, /register\.js$/i);
apps.keys().map(key => {
    const name = key.replace('./','').replace('modules/','').replace('register.js','');
    console.log(name);
    require('../../modules/'+name+'register.js');
});

const vendorApps = require.context('../../vendor', true, /register\.js$/i);
vendorApps.keys().map(key => {
    const name = key.replace('./','').replace('vendor/','').replace('ybm/','').replace('register.js','');
    //console.log(name);
    require('../../vendor/ybm/'+name+'register.js');
});

import eventBus from "./utils/eventBus";
Vue.prototype.$eventBus = eventBus;

import vuetify from './plugins/Vuetify';

const app = window.vue = new Vue({
    el: '#app',
    vuetify
});
